module.exports = __webpack_public_path__ + "static/media/nationalparks.09f37eb8.png";